<template>
    <div class="fill-height">
        <TabBasic ref="tabBasic" :items="items" show-breadcrumbs :user-id="selectedUserId">
            <template v-slot:header>
                <v-spacer/>
                <slot name="header"/>
                <v-col cols="3">
                </v-col>
            </template>
        </TabBasic>
    </div>
</template>

<script>
import TabBasic from "@/components/reusable/TabBasic/TabBasic";

export default {
  name: "OrganizationSettings",
  components: {TabBasic},
  mounted() {
    this.getUsers()
  },
  data() {
    return {
      tab: null,
      selectedUserId: this.$store.getters.getUserId,
      users: [],
      items: [
        {
          title: this.$t('settings.myOrganization'),
          to: {
            name: 'subscriptionSettings'
          }
        },
        {
          title: this.$t('settings.notificationAlerts'),
          to: {
            name: 'notificationsAndAlerts'
          }
        },/*
        {
          title: 'Email templates',
          to: {
            name: 'emailTemplates'
          }
        },*/
      ],
      openAddEditDialog: false,
    };
  },
  methods: {
    getUsers() {
      let url = this.$store.getters.getOrganizationUsers(this.$store.getters.getOrganizationId);
      this.loading = true;
      this.axios.get(url).then(({data}) => {
        this.users = data.Result.map(user => ({value: user.UserID, text: user.FullName}));
      }).finally(() => {
        this.loading = false;
      });
    },
  }
};
</script>

<style lang="scss" scoped>
@import "organization-settings";
</style>